import In2CLCMarkPage from "./In2CLCMarkPage";

export default In2CLCMarkPage;
